import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["overlay", "disabled", "placement", "children", "value"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Created by Yash Sharma on 07/12/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Button } from 'antd';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import { Consumer } from '../AntdPopupContainerContext';
import { computeGetPopupContainerProp } from '../../utils/popUpUtils';
var computeDropdownExtraProps = function computeDropdownExtraProps(_ref) {
  var scrollParentSelector = _ref.scrollParentSelector,
    scrollParentRef = _ref.scrollParentRef;
  return Object.assign({}, computeGetPopupContainerProp({
    scrollParentRef: scrollParentRef,
    scrollParentSelector: scrollParentSelector
  }));
};
var DropDown = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DropDown, _React$PureComponent);
  var _super = _createSuper(DropDown);
  function DropDown() {
    _classCallCheck(this, DropDown);
    return _super.apply(this, arguments);
  }
  _createClass(DropDown, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        overlay = _this$props.overlay,
        disabled = _this$props.disabled,
        placement = _this$props.placement,
        children = _this$props.children,
        value = _this$props.value,
        rest = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React.createElement(Consumer, null, function () {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT,
          scrollParentRef = _ref2.scrollParentRef,
          scrollParentSelector = _ref2.scrollParentSelector;
        var extraProps = computeDropdownExtraProps({
          scrollParentSelector: scrollParentSelector,
          scrollParentRef: scrollParentRef
        });
        return /*#__PURE__*/React.createElement(Dropdown, _extends({}, rest, extraProps, {
          disabled: disabled,
          overlay: overlay,
          placement: placement
        }), children || /*#__PURE__*/React.createElement(Button, {
          disabled: disabled
        }, value || 'Select'));
      });
    }
  }]);
  return DropDown;
}(React.PureComponent);
_defineProperty(DropDown, "propTypes", {
  placement: PropTypes.oneOf(['bottomCenter', 'bottomLeft', 'bottomRight', 'topLeft', 'topCenter', 'topRight']),
  overlay: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  children: PropTypes.node
});
_defineProperty(DropDown, "defaultProps", {
  placement: 'bottomCenter',
  disabled: false,
  value: 'Select',
  children: ''
});
_defineProperty(DropDown, "Button", Dropdown.Button);
export default DropDown;